// src/components/AdminLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { loginAdmin } = useAuth();
  const logoUrl = process.env.PUBLIC_URL + '/logo.jpeg';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    try {
      const response = await axios.post(`${API_BASE_URL}/admin/login`, {
        name: email,
        password,
      });
      console.log('Admin Login Success:', response.data);
      
      // Store authentication token
      const token = response.data.token || 'admin-authenticated';
      loginAdmin(token, email);
      
      navigate('/admin-dashboard'); // Redirect on success
    } catch (error) {
      setError('Invalid email or password');
    }
  };

  return (
    <div className="login-page">
      <div className="login-header">
        <img src={logoUrl} alt="Logo" className="login-logo" />
        <h1 className="login-title">SHREE SIDDHARAMESHWAR FINANCE AND LEASING</h1>
      </div>
      <div className="box">
        <div className="box-form">
          <div className="box-login-tab"></div>
          <div className="box-login-title">
            <div className="i i-login"></div>
            <h2>ADMIN LOGIN</h2>
          </div>
          <div className="box-login">
            <div className="fieldset-body" id="login_form">
              <form onSubmit={handleSubmit}>
                <p className="field">
                  <label htmlFor="user">E-MAIL</label>
                  <input
                    type="email"
                    id="user"
                    name="email"
                    title="Username"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </p>
                <p className="field">
                  <label htmlFor="pass">PASSWORD</label>
                  <input
                    type="password"
                    id="pass"
                    name="password"
                    title="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </p>
                <label className="checkbox">
                  <input
                    type="checkbox"
                    value="TRUE"
                    title="Keep me Signed in"
                  />{' '}
                  Keep me Signed in
                </label>
                <input
                  type="submit"
                  id="do_login"
                  value="GET STARTED"
                  title="Get Started"
                />
              </form>
              {error && <p className="error">{error}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
